module.exports = __webpack_public_path__ + "media/src/application/media/animation/step-d657279965b22fe7e6e159f83b0c5803.svg";